import i18n from '@/libs/i18n'

export default [
  {
    id: 'weekly',
    name: i18n.tc('field.weekly'),
  },
  {
    id: 'monthly',
    name: i18n.tc('field.monthly'),
  },
]
